export enum enmCurrency {
    TL = 0, EURO = 1, USD = 2, GBP = 3
}